import { AuthUserService, IAuthUser } from '../services/authusers.service';
class AuthSettingsUsersController implements ng.IComponentController {
    
    private authUsers: IAuthUser[];

    constructor(private AuthUserService: AuthUserService ) {
        'ngInject';
    }

    public $onInit = () => {
       
    }
}

export const authSettingsUsersComponent : ng.IComponentOptions = {
    bindings : {
        authUsers: "<"
    },
    controller : AuthSettingsUsersController,
    template : require('./authsettings.users.html')
};



// WEBPACK FOOTER //
// ./src/app/authsettings/components/authsettings.users.component.ts